const items = [
  "STÚDIÓ MINŐSÉG",
  "48 / 96 NAPOS SZÁLLÍTÁS",
  "RÉSZLETFIZETÉSI KONSTRUKCIÓK",
  "3 ÉV GARANCIA",
];

export const Marquee = () => (
  <div className="bg-[var(--ink)] py-5 overflow-hidden relative" data-testid="marquee-strip">
    <div className="marquee-track flex whitespace-nowrap w-max">
      {[0, 1].map((rep) => (
        <div key={rep} className="flex items-center">
          {items.map((t) => (
            <span key={`${rep}-${t}`} className="flex items-center">
              <span className="font-serif-d italic text-[#faf8f5] text-lg tracking-wide px-8">{t}</span>
              <span className="text-[var(--terra)] text-xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
